import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { SIZE, ORIENTATION } from '../constants';
export class Separator extends React.PureComponent {
    render() {
        let className = this.props.size === SIZE.A4 ? ' rpx-separator-a4' : '';
        className += this.props.size === SIZE.A3 ? ' rpx-separator-a3' : '';
        className += this.props.orientation === ORIENTATION.PORTRAIT ? ' rpx-separator-portrait' : '';
        className += this.props.orientation === ORIENTATION.LANDSCAPE ? ' rpx-separator-landscape' : '';
        return _jsx("div", { className: 'rpx-separator' + className });
    }
}
//# sourceMappingURL=separator.js.map